import { FormProps, FormValuesProps } from '../interfaces/form'

import FormWizard from './wizard'
import Household from './sections/household'
import PersonalDetails from './sections/personalDetails'
import Smoker from './sections/smoker'
import Income from './sections/income'
import Postcode from './sections/postcode'
import LivingStatus from './sections/livingStatus'
import Loans from './sections/loans'
import MonthlyExpenses from './sections/monthlyExpenses'
import EmergencyFunds from './sections/emergencyFunds'
import SickPay from './sections/sickPay'
import EmployeeBenefits from './sections/employeeBenefits'
import Policies from './sections/policies'
import QuoteList from './sections/quoteList'
import EmploymentStatus from './sections/employmentStatus'
import BookAppointment from './sections/bookAppointment'
import Occupation from './sections/occupation'
import PartnerCoverage from './sections/partnerCoverage'
import PersonalDetailsPartner from './sections/personalDetailsPartner'
import SmokerPartner from './sections/smokerPartner'
import EmploymentStatusPartner from './sections/employmentStatusPartner'
import IncomePartner from './sections/incomePartner'
import OccupationPartner from './sections/occupationPartner'
import {
  validateHouseHold,
  validatePersonalDetails,
  validateSmoker,
  validateIncome,
  validatePostcode,
  validateLivingStatus,
  validateLoans,
  validateMonthlyExpenses,
  validateEmergencyFunds,
  validateSickPay,
  validateEmployeeBenefits,
  validatePolicies,
  validateEmploymentStatus,
  validateAppointment,
  validateOccupation,
  validatePartnerCoverage,
  validatePartnerPersonalDetails,
  validatePartnerSmoker,
  validatePartnerEmploymentStatus,
  validatePartnerIncome,
  validatePartnerOccupation,
} from './validation'
import BrooksonWelcomePage from './sections/brooksonWelcomePage'
import { useTheme } from '@mui/material'

const HomeForm = ({
  handleSubmit,
  initialValues,
  setFormValues,
  formValues,
}: FormProps) => {
  const theme = useTheme();
  //@ts-ignore
  const custom = theme?.custom;

  const IsEmployedOrSelfEmployed = (values: FormValuesProps) => {
    return (
      values?.employment === 'SelfEmployed' || values?.employment === 'Employed' ||
      values?.employment === 'Contractor'
    )
  }

  const IsPartnerEmployedOrSelfEmployed = (values: FormValuesProps) => {
    return (
      values?.partnerEmployment === 'SelfEmployed' ||
      values?.partnerEmployment === 'Employed' ||
      values?.partnerEmployment === 'Contractor'
    )
  }

  const IsPartnerCovered = (values: FormValuesProps) => {
    return values?.isPartnerCovered === 'true'
  }

  return (
    <FormWizard
      setFormValues={setFormValues}
      initialValues={initialValues}
      pages={[
        <BrooksonWelcomePage
          hideNextButton={true}
          hidePreviousButton={true}
          skip={() => custom?.apiKey !== "2d6fe9fa-ead6-4bb4-b285-90967190067a"}
        />,
        <Household
          validate={validateHouseHold}
          hideNextButton={true}
          hidePreviousButton={custom?.apiKey !== "2d6fe9fa-ead6-4bb4-b285-90967190067a" ? true : false}
        />,
        <PartnerCoverage
          validate={validatePartnerCoverage}
          skip={(values) =>
            values?.household !== 'Me and my partner' &&
            values?.household !== 'Me, my partner and my children'
          }
          hideNextButton={true}
        />,
        <PersonalDetails validate={validatePersonalDetails} />,
        <PersonalDetailsPartner
          validate={validatePartnerPersonalDetails}
          skip={(values) => !IsPartnerCovered(values)}
        />,
        <Smoker validate={validateSmoker} />,
        <SmokerPartner
          validate={validatePartnerSmoker}
          skip={(values) => !IsPartnerCovered(values)}
        />,
        <EmploymentStatus
          validate={validateEmploymentStatus}
          hideNextButton={true}
        />,
        <EmploymentStatusPartner
          validate={validatePartnerEmploymentStatus}
          hideNextButton={true}
          skip={(values) => !IsPartnerCovered(values)}
        />,
        <Income
          validate={validateIncome}
          skip={(values) => !IsEmployedOrSelfEmployed(values)}
        />,
        <IncomePartner
          validate={validatePartnerIncome}
          skip={(values) =>
            !IsPartnerCovered(values) ||
            !IsPartnerEmployedOrSelfEmployed(values)
          }
        />,
        <Occupation
          validate={validateOccupation}
          skip={(values) => !IsEmployedOrSelfEmployed(values)}
        />,
        <OccupationPartner
          validate={validatePartnerOccupation}
          skip={(values) =>
            !IsPartnerCovered(values) ||
            !IsPartnerEmployedOrSelfEmployed(values)
          }
        />,
        <Postcode validate={validatePostcode} />,
        <LivingStatus
          validate={validateLivingStatus}
          hideNextButton={true}
          skip={(values) =>
            !IsEmployedOrSelfEmployed(values) &&
            !IsPartnerEmployedOrSelfEmployed(values)
          }
        />,
        <Loans
          validate={validateLoans}
          hideNextButton={true}
          skip={(values) =>
            !IsEmployedOrSelfEmployed(values) &&
            !IsPartnerEmployedOrSelfEmployed(values)
          }
        />,
        <MonthlyExpenses
          validate={validateMonthlyExpenses}
          skip={(values) =>
            !IsEmployedOrSelfEmployed(values) &&
            !IsPartnerEmployedOrSelfEmployed(values)
          }
        />,
        <EmergencyFunds
          validate={validateEmergencyFunds}
          skip={(values) =>
            !IsEmployedOrSelfEmployed(values) &&
            !IsPartnerEmployedOrSelfEmployed(values)
          }
        />,
        <SickPay
          validate={validateSickPay}
          skip={(values) =>
            values?.employment !== 'Employed' &&
            values?.partnerEmployment !== 'Employed'
          }
        />,
        <EmployeeBenefits
          validate={validateEmployeeBenefits}
          skip={(values) =>
            !IsEmployedOrSelfEmployed(values) &&
            !IsPartnerEmployedOrSelfEmployed(values)
          }
        />,
        <Policies
          validate={validatePolicies}
          skip={(values) =>
            !IsEmployedOrSelfEmployed(values) &&
            !IsPartnerEmployedOrSelfEmployed(values)
          }
        />,
        <QuoteList hideButtons={true} skip={() => custom?.apiKey === "2d6fe9fa-ead6-4bb4-b285-90967190067a"} />,
        <BookAppointment validate={validateAppointment} hideButtons={true} />,
      ]}
      onSubmit={handleSubmit}
    />
  )
}

export default HomeForm
